/* eslint-disable camelcase */
import PropTypes from "prop-types";

function TransferTaskCard(props) {
  const {
    // status,
    // statusName,
    itemId,
    itemIdText,
    headingValue,
    headingText,
    toggleDetails,
    // statusDictionary,
    date,
    item,
    // hasInfoText,
    hasDeleteButton,
    deleteFunction,
    secondHeadingValue,
    secondHeadingText,
    hasReports,
    reportsFunction,
  } = props;
  return (
    <div className="ttcard">
      <div className="ttcard__details">
        <span className="ttcard__heading">{itemIdText}</span>
        <span className="value">{itemId}</span>
      </div>
      <div className="ttcard__date-status">
        <span className="ttcard__heading">{secondHeadingText}</span>
        <span className="value">{secondHeadingValue}</span>
        {hasDeleteButton && (
          <button
            type="button"
            className="delete_btn"
            onClick={deleteFunction.bind(this, item)}
          >
            <i className="fa-regular fa-trash-can" />
          </button>
        )}
        {hasReports && (
          <button
            type="button"
            className="details_btn"
            onClick={reportsFunction.bind(this, item)}
          >
            <i className="fa-regular fa-file" />
          </button>
        )}
        {toggleDetails && (
          <button
            type="button"
            onClick={toggleDetails.bind(this, item)}
            className="details_btn"
          >
            <img
              alt="arrow"
              src={`${process.env.PUBLIC_URL}/imgs/Icon feather-arrow-left.svg`}
            />
          </button>
        )}
      </div>
      <div className="d-grid">
        <span className="ttcard__heading">{headingText}</span>
        <span className="value">{headingValue}</span>
      </div>
      <div className="date">
        <span style={{ fontSize: "13px" }}>
          <img
            alt="cal"
            src={`${process.env.PUBLIC_URL}/imgs/CalendarIcon.svg`}
          />
          {date}
        </span>
      </div>
    </div>
  );
}

TransferTaskCard.defaultProps = {
  // hasInfoText: false,
  hasDeleteButton: false,
  hasReports: false,
  //   statusName: "",
  deleteFunction: () => {},
  reportsFunction: () => {},
};

TransferTaskCard.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  toggleDetails: PropTypes.func.isRequired,
  // status: PropTypes.number.isRequired,
  //   statusName: PropTypes.string,
  itemId: PropTypes.string.isRequired,
  headingValue: PropTypes.string.isRequired,
  headingText: PropTypes.string.isRequired,
  secondHeadingValue: PropTypes.string.isRequired,
  secondHeadingText: PropTypes.string.isRequired,
  itemIdText: PropTypes.string.isRequired,
  // hasInfoText: PropTypes.bool,
  hasDeleteButton: PropTypes.bool,
  hasReports: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  // statusDictionary: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  item: PropTypes.object.isRequired,
  date: PropTypes.string.isRequired,
  deleteFunction: PropTypes.func,
  reportsFunction: PropTypes.func,
};

export default TransferTaskCard;
